var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DIV",
    { staticClass: "badge border" },
    [
      _c("ItpIcon", { attrs: { icon: "ic:baseline-cable" } }),
      _vm._v(" "),
      _c("span", [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }